import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class UnsavedChangesService {
  private currentForm: FormGroup | null = null;
  private hasCompletedOnce = false;

  /**
   * Register a form for tracking unsaved changes
   * @param form - The FormGroup to track
   */
  registerForm(form: FormGroup): void {
    this.unregisterForm();
    this.currentForm = form;
  }

  /**
   * Mark the current form as completed
   */
  markFormCompleted(): void {
    this.hasCompletedOnce = true;
    this.currentForm = null;
  }

  /**
   * Check if any registered form has unsaved changes
   * @returns true if any form has unsaved changes and hasn't been completed
   */
  hasUnsavedChanges(): boolean {
    if (this.hasCompletedOnce || !this.currentForm) {
      return false;
    }

    // Check if form is dirty (has changes) and has filled values
    const isDirty = this.currentForm.dirty;
    const hasFilledValues = this.hasAnyFilledValues(this.currentForm.value);

    return isDirty && hasFilledValues;
  }

  /**
   * Unregister a form when component is destroyed
   * @param form - The FormGroup to unregister
   */
  unregisterForm(): void {
    this.currentForm = null;
    this.hasCompletedOnce = false;
  }

  private hasAnyFilledValues(formValue: Record<string, unknown>): boolean {
    return Object.values(formValue).some((value) => {
      if (value === null || value === undefined || value === '') {
        return false;
      }
      if (Array.isArray(value)) {
        return value.length > 0;
      }
      return true;
    });
  }
}
